/**
 * Tastenregel für die `@`- und `#`-Auswahl (T-50).
 *
 * Die Auswahl bekommt NIE den Fokus: Er bleibt bewusst im Schreibfeld, sonst
 * wäre die Cursorposition weg, an der Erwähnung oder Verweis landen sollen
 * (siehe `AuswahlAnker`). Deshalb fängt das Schreibfeld die Tasten selbst ab
 * und fragt hier, was die Taste bei offener Auswahl bedeutet. Der „aktive"
 * Vorschlag ist ein kontrollierter Zustand des Schreibfelds und wird an die
 * Picker durchgereicht. Vorbild: `chat/ChatComposer.tsx`.
 *
 * - ↑/↓ wechseln den Vorschlag (zyklisch),
 * - Enter und Tab übernehmen den aktiven Vorschlag,
 * - alles andere — auch Shift+Enter (Zeilenumbruch), Strg/⌘+Enter (Senden)
 *   und Tasten während einer IME-Eingabe — gehört dem Feld (`null`).
 */

export type AuswahlTasteEreignis = {
    key: string;
    ctrlKey?: boolean;
    metaKey?: boolean;
    altKey?: boolean;
    shiftKey?: boolean;
    nativeEvent?: { isComposing?: boolean };
};

export type AuswahlTasteErgebnis =
    | { art: "weiter"; aktiv: number }
    | { art: "waehlen"; index: number };

export function auswahlTaste(
    e: AuswahlTasteEreignis,
    anzahl: number,
    aktiv: number,
): AuswahlTasteErgebnis | null {
    if (anzahl <= 0) return null;
    if (e.nativeEvent?.isComposing) return null;
    if (e.ctrlKey || e.metaKey || e.altKey) return null;
    // Ein verrutschter Index (Trefferliste ist geschrumpft) zählt als erster.
    const jetzt = aktiv >= 0 && aktiv < anzahl ? aktiv : 0;
    switch (e.key) {
        case "ArrowDown":
            if (e.shiftKey) return null;
            return { art: "weiter", aktiv: (jetzt + 1) % anzahl };
        case "ArrowUp":
            if (e.shiftKey) return null;
            return { art: "weiter", aktiv: (jetzt - 1 + anzahl) % anzahl };
        case "Enter":
        case "Tab":
            if (e.shiftKey) return null;
            return { art: "waehlen", index: jetzt };
        default:
            return null;
    }
}
